import mapboxgl from "mapbox-gl";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_PK;

export const initializeMap = (mapRef, mapContainerRef, style, onReady) => {
  if (mapRef.current) return; // StrictMode safe

  mapRef.current = new mapboxgl.Map({
    container: mapContainerRef.current,
    style,
    // center: [10.1815, 36.8065],
    // zoom: 6,
     center: [6.15, 43.4], // Var, France
    zoom: 9, // Zoom into the Var department
     attributionControl: false,
  });

  mapRef.current.on("load", () => onReady?.());
};
export const locateUser = (map, onDone) => {
  if (!navigator.geolocation) return onDone?.();
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      const center = [coords.longitude, coords.latitude];
      map.flyTo({ center, zoom: 14 });
      onDone?.(center);
    },
    (err) => {
      console.error("geolocation failed", err);
      onDone?.();
    },
    { enableHighAccuracy: true, timeout: 10000 },
  );
};

export const toggleFullscreen = () => {
  if (document.fullscreenElement) document.exitFullscreen();
  else document.documentElement.requestFullscreen?.();
};

export const changeMapStyle = (map, styleUrl) =>
  map.setStyle(styleUrl, { diff: false });